// extracted by mini-css-extract-plugin
export default {"avatarContainer":"avatar_avatarContainer__jMyjh","avatar":"avatar_avatar__d-+Zq","selected":"avatar_selected__T7eXK"};